import { styled, Box } from '@mui/material';

export const StyledEmptyListCreateNewWrapper = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  '& h4': { marginBottom: theme.spacing(1) },
  '& p': { margin: 0 },
  '& button': { marginTop: theme.spacing(2) },
}));
